import { useMemo } from 'react';
import { useSettings } from '../contexts/SettingsContext';
import { useUserSettings } from '../modules/admin/settings/useData';
import { useAccountVesselScope } from './useAccountVesselScope';
import { resolveSidebarLayout, SidebarLayoutMode } from '../config/sidebarLayout';

export function useEffectiveSidebarLayout(): SidebarLayoutMode {
  const { appConfig } = useSettings();
  const { userSettings } = useUserSettings();
  const vesselAccountId = useAccountVesselScope();
  const isVesselAccount = vesselAccountId != null;

  return useMemo(
    () =>
      resolveSidebarLayout(
        userSettings?.sidebarLayout ?? null,
        appConfig.layout.sidebarStyle,
        isVesselAccount,
      ),
    [userSettings?.sidebarLayout, appConfig.layout.sidebarStyle, isVesselAccount],
  );
}
